import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Stock from "@/pages/Stock";
import Cutting from "@/pages/Cutting";
import Orders from "@/pages/Orders";
import Shipments from "@/pages/Shipments";
import Backup from "@/pages/Backup";
import Fair from "@/pages/Fair";
import FairOrderPrint from "@/pages/FairOrderPrint";
import FairSummaryPrint from "@/pages/FairSummaryPrint";
import Products from "@/pages/Products";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Waybill from "@/pages/Waybill";
import Shortage from "@/pages/Shortage";
import Soles from "@/pages/Soles";
import KoliTypes from "@/pages/KoliTypes";
import SoleOrder from "@/pages/SoleOrder";
import SoleOrders from "@/pages/SoleOrders";
import SoleOrderPrint from "@/pages/SoleOrderPrint";
import OrderPrint from "./pages/OrderPrint";
import CuttingPrint from "@/pages/CuttingPrint";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Staff from "@/pages/Staff";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<Login />} />
            <Route element={<RequireAuth />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/kart" element={<Products />} />
              <Route path="/musteri" element={<Customers />} />
              <Route path="/musteri/:id" element={<CustomerDetail />} />
              <Route path="/eksik" element={<Shortage />} />
              <Route path="/taban" element={<Soles />} />
              <Route path="/taban-siparisleri" element={<SoleOrders />} />
              <Route path="/koli" element={<KoliTypes />} />
              <Route path="/stok" element={<Stock />} />
              <Route path="/kesim" element={<Cutting />} />
              <Route path="/siparis" element={<Orders />} />
              <Route path="/sevkiyat" element={<Shipments />} />
              <Route path="/fuar" element={<Fair />} />
              <Route path="/yedek" element={<Backup />} />
              <Route path="/personel" element={<Staff />} />
            </Route>
            <Route path="/irsaliye/:id" element={<Waybill />} />
            <Route path="/taban-siparis" element={<SoleOrder />} />
            <Route path="/taban-siparis-fis/:id" element={<SoleOrderPrint />} />
            <Route path="/kesim-fis/:id" element={<CuttingPrint />} />
            <Route path="/siparis-fis/:id" element={<OrderPrint />} />
            <Route path="/fuar-fis/:id" element={<FairOrderPrint />} />
            <Route path="/fuar-ozet" element={<FairSummaryPrint />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="light" position="top-right"
          toastOptions={{ style: { background: "#FFFBF4", border: "1px solid #DCCFB8", color: "#2B2118" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
